// extracted by mini-css-extract-plugin
export var label = "_fi-0";
export var treatmentCard = "_fi-1";